export const getRandomUUID = (): string => crypto.randomUUID()
